import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    planetTitleTextPosition: {x: 408, y: 294},
    mobilePlanetTitleTextPosition: {x: 282, y: 401},
    titleRocketStopXPosition: 382,
    mobileTitleRocketStopXPosition: 254,
    titleRocketYPosition: 404,
    mobileTitleRocketYPosition: 532,
  };

  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.planetTitleTextPosition = {x: 424, y: 381};
      config.mobilePlanetTitleTextPosition = {x: 291, y: 503};
      config.titleRocketStopXPosition = 175;
      config.mobileTitleRocketStopXPosition = 125;
      config.titleRocketYPosition = 135;
      config.mobileTitleRocketYPosition = 225;
      break;
  }

  return config;
}